import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import apiService from '../services/apiService';
import { storyPeriod, storyPages, renderStory } from '../lib/scheduleStory';

export default function ScheduleStoryDialog({ open, onOpenChange, currentDate, view }) {
  const [images, setImages] = useState([]);
  const [page, setPage] = useState(0);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    const urls = [];
    setLoading(true); setError(''); setImages([]); setPage(0);
    (async () => {
      try {
        const slots = await apiService.getSlots(true);
        if (document.fonts) await Promise.all([document.fonts.load('48px Fraunces'), document.fonts.load('32px Montserrat')]);
        const period = storyPeriod(currentDate, view);
        const pages = storyPages(slots, period);
        for (let i = 0; i < pages.length; i++) {
          if (cancelled) return;
          const canvas = renderStory(document.createElement('canvas'), pages[i], period, i, pages.length);
          const blob = await new Promise((resolve, reject) => canvas.toBlob(value => value ? resolve(value) : reject(new Error('Image indisponible')), 'image/png'));
          if (cancelled) return;
          urls.push({ url: URL.createObjectURL(blob), filename: `koreanbyali-story-${period.start}-${i + 1}.png` });
        }
        if (!cancelled) setImages([...urls]);
      } catch (e) {
        if (!cancelled) setError('Impossible de préparer le planning. Fermez cette fenêtre et réessayez.');
      } finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; urls.forEach(image => URL.revokeObjectURL(image.url)); };
  }, [open, currentDate, view]);
  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[94dvh] overflow-y-auto">
      <DialogHeader><DialogTitle>Votre planning en story</DialogTitle><DialogDescription>PNG · 1080 × 1920 · Disponibilités à venir uniquement. Téléchargez chaque page, puis ajoutez-la à votre story Instagram.</DialogDescription></DialogHeader>
      {loading && <p role="status">Préparation des disponibilités…</p>}
      {error && <p role="alert">{error}</p>}
      {!loading && images[page] && <>
        <img src={images[page].url} alt={`Aperçu du planning, page ${page + 1} sur ${images.length}`} className="mx-auto w-auto max-w-full max-h-[52dvh] border border-neutral-200" />
        <div className="flex items-center justify-between gap-2">
          <Button variant="outline" disabled={page === 0} onClick={() => setPage(page - 1)} aria-label="Page précédente">←</Button>
          <span aria-live="polite">Page {page + 1} / {images.length}</span>
          <Button variant="outline" disabled={page === images.length - 1} onClick={() => setPage(page + 1)} aria-label="Page suivante">→</Button>
        </div>
        <Button asChild className="bg-neutral-900 text-white hover:bg-neutral-700"><a href={images[page].url} download={images[page].filename}>Télécharger cette story</a></Button>
      </>}
    </DialogContent>
  </Dialog>;
}
